import React from "react"

const Terms = () => {
  return (
    <section className="container mx-auto px-6 pt-20 w-2/3">
      <h2 className="text-2xl font-bold">Terms of use</h2>
      <p className="pb-20">Last Updated: 01/29/2021</p>

      <p className="pb-4">
        These Terms of Use (hereinafter “ToU”) govern your use of the Avalith
        Corp. and its affiliated companies around the world (hereinafter
        referenced as “Avalith”, “we”, “us” or “our”) website located at
        www.avalith.net (hereinafter referenced as “Site”) and the various sites
        connected to this page.
      </p>

      <p className="pb-4">
        This Site is made available for information purposes, submission for
        contact by our business development to become a client or partner, or
        for consideration into our teams as an employee of Avalith.
      </p>

      <p className="pb-4">
        By using this Site, you are agreeing to the following ToU. If you do not
        want or do not agree to have these terms apply to you, you should
        immediately stop using our Site:
      </p>

      <h4 className="pb-4 font-bold text-xl">Site Rules</h4>
      <p className="pb-4">
        If you do not stop or continue using our Site, you agree to only access
        this Site as intended by Avalith. You shall not access or attempt to
        access our Site by any other means, or through any other interfaces
        unless so authorized. You further agree not to engage in any other
        activities that would otherwise interfere with the use, access, or
        availability of our Site including, but not limited to, copying,
        reproducing, duplicating, selling, trading or reselling our Site for any
        unauthorized purposes, or web crawling of any kind.
      </p>

      <p className="pb-4">
        Unless otherwise stated, the contents of this site including, but not
        limited to, the text and images contained herein and their arrangement
        are the property of Accenture. All trademarks used or referred to in
        this website are the property of their respective owners.
      </p>

      <p className="pb-4">
        Nothing contained in this Site shall be construed as conferring by
        implication, estoppel, or otherwise, any license or right to any
        copyright, patent, trademark or other proprietary interest of Avalith or
        any third party. This Site and the content provided in this Site,
        including, but not limited to the Avalith logo and trademarks, graphic
        images, audio, video, source code, buttons, and text, may not be copied,
        reproduced, republished, uploaded, posted, transmitted, or distributed
        in any way, without the prior written consent of Avalith, except that
        you may download, display, and print one copy of the materials on any
        single computer solely for your personal, non-commercial use, provided
        that you do not modify the material in any way and you keep intact all
        copyright, trademark, and other proprietary notices.
      </p>

      <h4 className="pb-4 font-bold text-xl">Contents</h4>
      <p className="pb-4">
        The information provided on this Site is free of charge and for
        informational purposes only and does not by itself create a business or
        professional services relationship between you and Avalith. Links on
        this site may lead to services or sites not operated by Avalith. No
        judgment or warranty is made with respect to such other services or
        sites and Avalith takes no responsibility or liability whatsoever for
        such other sites or services, nor for any associated event or activity.
        A link to another site or service is not an endorsement of that site or
        service. Any use you make of the information provided on this site, or
        any site or service linked to by this site, is at your own risk, and any
        dealings between you and any third party associated with such sites is
        entirely within you and such third party.
      </p>

      <p className="pb-4">
        This Site and its contents are provided "as is" and Avalith makes no
        representation or warranty of any kind with respect to this site or any
        site or service accessible through this site. Avalith expressly
        disclaims all express and implied warranties including, but not limited
        to, the implied warranties of merchantability, fitness for a particular
        purpose, title, and non-infringement. In no event will either Avalith or
        its third-party service providers be liable to any party for any direct,
        indirect, incidental, special, exemplary, consequential, or other
        damages (including, but not limited to, lost profits, business
        interruption, loss of programs or data) without regard to the form of
        action and whether in contract, tort, negligence, strict liability, or
        otherwise, arising out of or in connection with this Site, any content
        on or accessed through this Site or any site service linked to, or any
        copying, displaying, or use thereof.
      </p>

      <h4 className="pb-4 font-bold text-xl">Privacy</h4>
      <p className="pb-4">
        Any personal data that is collected or processed by Avalith will be done
        in accordance with our Privacy Policy. Any unauthorized idea submission
        outside of established and documented confidential business
        relationships made through this website is not encouraged, and will not
        be treated in confidence. Avalith may therefore develop, use and freely
        disclose or publish similar ideas without the need for compensation,
        accounting or credit.
      </p>

      <h4 className="pb-4 font-bold text-xl">No offer</h4>
      <p className="pb-4">
        Avalith (a) does not guarantee that you will receive any employment, job
        offers, or call backs through our Site, (b) will not be responsible for
        any listings, submissions, or request from information from you, and (c)
        is not your employer or your agent based on your usage of our Site.
      </p>

      <p className="pb-4">
        Avalith reserves the right, in its sole discretion and authority, to
        restrict, terminate, suspend or otherwise limit this ToU and any access
        to part or all of our Site at any time and for any reason whatsoever
        with or without notice or liability.
      </p>

      <p className="pb-4">
        Avalith further reserves the right to alter, change, update, discontinue
        or suspend access to party or all of our Site at any time and for any
        reason whatsoever with or without notice or liability.
      </p>

      <h4 className="pb-4 font-bold text-xl">Indemnification</h4>
      <p className="pb-4">
        You agree to indemnify, defend, and hold Avalith Corp., its affiliates
        and subsidiaries, employees, officers, directors, and agents harmless
        from and against any and all claims, liabilities, damages, judgments,
        awards, losses, costs, expenses and fees (including attorneys’ fees)
        arising out of your breach of this ToU, relating to your access,
        connection, activities, and engagement with our Site, or any violations
        of our Privacy Policy and/or applicable laws. Avalith reserves the right
        to assume the exclusive defense and control of any matter which is
        subject to indemnification under this section and ToU. In such a case,
        you agree to cooperate with any reasonable requests assisting Avalith
        defense of such matter.
      </p>

      <h4 className="pb-4 font-bold text-xl">Governing Law & Jurisdiction</h4>
      <p className="pb-4">
        These ToU are governed and will construed in accordance with the laws of
        the State of Florida, United States of America, without regard to any
        principles of conflicts of laws or your location. By using our site, you
        are agreeing to exclusive jurisdiction in both federal and state courts
        located in Broward county, the state of Florida, U.S.A., and you waive
        any jurisdictional, venue or inconvenient forum objects to such courts.
      </p>

      <h4 className="pb-4 font-bold text-xl">Security</h4>
      <p className="pb-4">
        You are responsible for complying with the laws of the jurisdiction from
        which you are accessing this site and you agree that you will not access
        or use the information on this site in violation of such laws. Unless
        expressly stated otherwise herein, any information submitted by you
        through this site shall be deemed non-confidential and non-proprietary.
        You represent that you have the lawful right to submit such information
        and agree that you will not submit any information unless you are
        legally entitled to do so. Because of the open nature of the Internet,
        we recommend that you not submit information you consider confidential.
      </p>

      <p className="pb-4">
        Information that is sent electronically or via the internet cannot be
        assured as completely secured and as such, Avalith cannot guarantee that
        unauthorized third parties will never be able to access or use
        electronic data, including your data, or that our security measures
        cannot be superseded. By using our Site, you acknowledge that any
        personal data you provide you do so at your own risk.
      </p>
    </section>
  )
}

export default Terms
